import { createAsyncThunk } from '@reduxjs/toolkit';
// Import Axios Admin API (this is where the baseURL is and shared reuqest params are set)
import api from '../../utils/api';
import { setAlert } from '../alerts/actions';

export const list = createAsyncThunk(
  'faqs/list',
  async (
    params = {
      page: 0,
      limit: 10,
      orderBy: null,
      orderDirection: null,
      filter: null,
      search: null,
    },
  ) => {
    try {
      const page = params.page ? params.page : 0;
      const limit = params.limit ? params.limit : 10;
      const res = await api.get(`/admin/faqs`, { params });
      console.log(page, limit);
      return { ...res.data, page, limit };
    } catch (error) {
      console.log(error);
    }
  },
);

export const create = createAsyncThunk(
  'faqs/create',
  async ({ data, navigate }, { dispatch }) => {
    try {
      const res = await api.post('/admin/faqs', data);
      dispatch(list());
      dispatch(
        setAlert({
          message: 'FAQs Added successfully',
          alertType: 'success',
        }),
      );
      if (navigate) navigate(`/cms/faqs`);
      return res.data;
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const edit = createAsyncThunk(
  'faqs/edit',
  async ({ id, data, navigate }, { dispatch }) => {
    try {
      console.log(data);
      await api.put(`/admin/faqs/${id}`, data);
      dispatch(
        setAlert({
          message: 'FAQs updated successfully',
          alertType: 'success',
        }),
      );
      dispatch(list());
      if (navigate) navigate(`/cms/faqs`);
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const get = createAsyncThunk('faqs/get', async (id, { dispatch }) => {
  try {
    const res = await api.get(`/admin/faqs/${id}`);
    return res.data;
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach((error) =>
        dispatch(setAlert({ message: error.message, alertType: 'error' })),
      );
    }
  }
});

export const order = createAsyncThunk(
  'faqs/order',
  async (data, { dispatch }) => {
    try {
      console.log(data);
      await api.post(`/admin/faqs/order`, { list: data });
      dispatch(
        setAlert({
          message: 'faqs order updated successfully',
          alertType: 'success',
        }),
      );
      dispatch(
        list({ page: -1, limit: -1, orderBy: 'order', orderDirection: 'ASC' }),
      );
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const remove = createAsyncThunk(
  'faqs/remove',
  async (id, { dispatch }) => {
    try {
      await api.delete(`/admin/faqs/${id}`);
      dispatch(
        setAlert({
          message: 'FAQs removed successfully',
          alertType: 'error',
        }),
      );
      dispatch(list());
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);

export const bulk_remove = createAsyncThunk(
  'faqs/bulk-remove',
  async ({ data }, { dispatch }) => {
    try {
      await api.post(`/admin/faqs/delete`, data);
      dispatch(
        setAlert({
          message: 'FAQss removed successfully',
          alertType: 'error',
        }),
      );
      dispatch(list());
    } catch (err) {
      const errors = err.response.data.errors;
      if (errors) {
        errors.forEach((error) =>
          dispatch(setAlert({ message: error.message, alertType: 'error' })),
        );
      }
    }
  },
);
